// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { pure } from 'recompose';

// Utils
import rawWordCount from '../../../../common/utils/editor/rawUtils/rawWordCount';
import { pluralise } from '../../../../common/utils/stringUtil';

const WordCount = ({ rawState }) => {
    const numberOfWords = rawState ? rawWordCount(rawState) : 0;
    return (
        <span className="WordCount">
            {numberOfWords} {pluralise('word', numberOfWords)}
        </span>
    );
};

WordCount.propTypes = {
    rawState: PropTypes.object,
};

export default pure(WordCount);
